/**
 * Add-to-Cart Loading Manager
 * Handles add-to-cart button state for products without subscription widgets
 */

class AddToCartLoader {
  constructor() {
    this.initTimeout = null
    this.isInitialized = false
  }

  /**
   * Initialize add-to-cart loading management
   */
  init() {
    // Don't run if subscription widget exists (it handles its own loading)
    if (document.querySelector('mitoq-subscription')) {
      console.log('📦 AddToCart Loader: Subscription widget found, skipping')
      return
    }

    console.log('🔄 AddToCart Loader: Managing non-subscription product')

    // Disable add-to-cart initially
    AddToCartLoader.disableAddToCartButtons()

    // Enable after delay to allow variant logic to process
    this.initTimeout = setTimeout(() => {
      AddToCartLoader.enableAddToCartButtons()
      this.isInitialized = true
      console.log('✅ AddToCart Loader: One-time product ready after delay')
    }, 1500) // 1.5s delay to match subscription products
  }

  /**
   * Disable all add-to-cart buttons
   */
  static disableAddToCartButtons() {
    const buttons = document.querySelectorAll(
      '.product-form__submit, [data-add-to-cart]'
    )

    buttons.forEach((button) => {
      button.disabled = true
      // Spinner is already visible from Liquid (no hidden class initially)
    })

    if (buttons.length > 0) {
      console.log(
        '🚫 AddToCart Loader: Disabled add-to-cart buttons during loading'
      )
    }
  }

  /**
   * Enable all add-to-cart buttons
   */
  static enableAddToCartButtons() {
    const buttons = document.querySelectorAll(
      '.product-form__submit, [data-add-to-cart]'
    )

    buttons.forEach((button) => {
      button.disabled = false
      // Hide loading spinner by adding hidden class back
      const spinner = button.querySelector('.loading__spinner')
      if (spinner) {
        spinner.classList.add('hidden')
      }
    })

    if (buttons.length > 0) {
      console.log('✅ AddToCart Loader: Enabled add-to-cart buttons')
    }
  }

  /**
   * Cleanup method
   */
  destroy() {
    if (this.initTimeout) {
      clearTimeout(this.initTimeout)
      this.initTimeout = null
    }
  }
}

// Initialize when DOM is ready
function initAddToCartLoader() {
  const loader = new AddToCartLoader()

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => loader.init())
  } else {
    loader.init()
  }
}

// Auto-initialize
initAddToCartLoader()

export default AddToCartLoader
